import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { HintTypeEnum } from '../../../hrm/models/hints-list.model';
import { salesPriceHints } from '../../price-hints.config';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from 'common/src/modules/rnpl-common/components/base-mega-hints/base-mega-hints.component';
import { ProductTypes } from 'common/src/modules/products/product-types';

@Component({
  selector: 'rnpl-sales-price-mega-hint',
  templateUrl: './sales-price-mega-hint.component.html',
  styleUrls: ['./sales-price-mega-hint.component.scss']
})
export class SalesPriceMegaHintComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {
  @Input() public screenName: string;
  @Input() public hasPrices: boolean;
  @Input() public activeTab: ProductTypes | string;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'PRICE.SALES_PRICES';
    this.megaHintTimer = 1200;
    this.displayHints();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('activeTab')) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.cancel();
      }

      if (!!this.screenName) {
        this.initHints();
      }
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = salesPriceHints(
            this.hasPrices,
            this.activeTab
          );

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!hints.data.hints && !!hints.data.hints.length && !hints.data.hints[0].viewed && hints.data.hints[0].type === HintTypeEnum.MEGA) {
            this.isCloseHint$.next(false);
            this.startTimerMegaHint();
          } else {
            if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
              this.shepherdService.start();
            }
          }
        }
      })
  }

}
